module.exports = __webpack_public_path__ + "static/media/seguranca_new.30d8aa22.png";